function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 28"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 6",
  fill: "#002f4d",
  stroke: "#707070"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 41,
  cy: 40,
  rx: 41,
  ry: 40,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 41,
  cy: 40,
  rx: 40.5,
  ry: 39.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-hands-helping",
  d: "M52.703 35.5H42.015v3.938a5.063 5.063 0 01-10.125 0v-8.551l-4.563 2.743a4.49 4.49 0 00-2.187 3.853v3.326l-5.625 3.248a2.245 2.245 0 00-.825 3.073l5.625 9.745a2.251 2.251 0 003.075.825l7.27-4.2h9.6a4.5 4.5 0 004.5-4.5h1.13a2.248 2.248 0 002.25-2.25v-4.5h.563a1.683 1.683 0 001.687-1.687v-3.375a1.683 1.683 0 00-1.687-1.688zm10.387-2.63l-5.627-9.745a2.251 2.251 0 00-3.073-.825l-7.27 4.2h-7.186a4.534 4.534 0 00-2.384.682l-2.36 1.47a2.235 2.235 0 00-1.05 1.905v8.88a2.813 2.813 0 005.625 0V33.25h12.938a3.94 3.94 0 013.938 3.938v2l5.625-3.248a2.252 2.252 0 00.824-3.07z",
  fill: "#e8f6f4"
}));
var SvgHandshakeIcon = function SvgHandshakeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 80"
  }, props), _ref);
};
export default SvgHandshakeIcon;